import { SendFeedbackActionTypes } from './types';
import { action } from 'typesafe-actions';

export const sendFeedbackStart = (payload: any) =>
  action(SendFeedbackActionTypes.SEND_FEEDBACK_START, payload);
export const sendFeedbackSuccess = (payload: any) =>
  action(SendFeedbackActionTypes.SEND_FEEDBACK_SUCCESS, payload);
export const sendFeedbackFailure = (error: string) =>
  action(SendFeedbackActionTypes.SEND_FEEDBACK_FAILURE, error);
